var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 571",
    style: {
      enableBackground: "new 0 0 400 571"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7142",
    className: "st0",
    d: "M389.4,193.5c-2-105-88.7-188.4-193.7-186.4C93.5,9,11.2,91.4,9.3,193.5c0,0.5-0.1,1-0.1,1.4 v2.9l0,0v343.7c0,11.7,9.5,21.1,21.1,21.1s21.1-9.5,21.1-21.1v-61.4c0-11.7,9.5-21.1,21.1-21.1s21.1,9.5,21.1,21.1l0,0v29.1 c0.3,11.7,9.9,20.9,21.6,20.7c11.3-0.2,20.4-9.4,20.7-20.7l0,0v-29.1c0-11.7,9.5-21.1,21.1-21.1l0,0c11.7,0,21.1,9.5,21.1,21.1v8 c0,11.7,9.5,21.1,21.1,21.1c11.7,0,21.1-9.5,21.1-21.1v-8c0.3-11.7,9.9-20.9,21.6-20.7c11.3,0.2,20.4,9.4,20.7,20.7v29.1 c0,11.7,9.5,21.1,21.1,21.1s21.3-9.3,21.3-21l0,0l0,0v-29.1c0-11.7,9.5-21.1,21.1-21.1l0,0c11.7,0,21.1,9.5,21.1,21.1v61.4 c0,11.7,9.5,21.1,21.1,21.1s21.1-9.5,21.1-21.1l0,0V195C389.5,194.5,389.5,194,389.4,193.5z M129.2,224c-18.7,0-33.8-17.3-33.8-38.8 s15.2-38.8,33.8-38.8s33.8,17.3,33.8,38.8S147.9,224,129.2,224L129.2,224z M200.8,278.8c-17,0-30.7-10.1-30.7-22.6 s13.8-4.9,30.7-4.9s30.7-7.5,30.7,4.9C231.5,268.6,217.8,278.7,200.8,278.8L200.8,278.8z M269.5,224c-18.7,0-33.8-17.3-33.8-38.8 s15.1-38.8,33.8-38.8s33.8,17.3,33.8,38.8S288.1,224,269.5,224L269.5,224z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13464"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_598",
    className: "st1",
    cx: 129.2,
    cy: 185.2,
    rx: 33.8,
    ry: 38.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7143",
    className: "st1",
    d: "M200.9,251.2c-17,0-30.7-7.5-30.7,4.9c0,12.4,13.8,22.6,30.7,22.6s30.7-10.1,30.7-22.6 S217.8,251.2,200.9,251.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_599",
    className: "st1",
    cx: 269.5,
    cy: 185.2,
    rx: 33.8,
    ry: 38.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/AAVE.77e7358d70b3894cf0ded200ed1c9fb5.svg";
export { ForwardRef as ReactComponent };